<template>
    <transition
        enter-from-class="opacity-0 translate-x-10"
        enter-active-class="transition overflow-hidden ease-in-out duration-150"
        enter-to-class="opacity-100 translate-x-0"
        leave-from-class="opacity-100 translate-x-0"
        leave-active-class="transition overflow-hidden ease-in-out duration-150"
        leave-to-class="opacity-0 translate-x-10"
    >
        <div v-if="filterVisible" class="absolute 2xl:sticky top-0 flex w-full flex-col md:max-w-6/12 lg:max-w-4/12 xl:max-w-3/12 2xl:max-w-3/12 3xl:max-w-2/12 max-w-[380px] h-screen dark:bg-slate-900 bg-stone-50 right-0 p-2 z-40 shadow-[-1px_0_10px_2px_rgba(0,0,0,0.1)]">
            <div class="px-2 py-2 w-full flex justify-between items-baseline">
                <button
                    class="tailx-btn-simple btn-simple-slate"
                    @click="store.dispatch('setFilterVisible')"
                >
                    <font-awesome-icon icon="arrow-right" />
                </button>

                <h4 class="dark:text-slate-300 text-slate-600 text-lg">FILTRO</h4>
                <div class="flex space-x-4 xl:space-x-2" >
                    <button
                        type="button"
                        @click="autoSearch = !autoSearch"
                        title="Buscar automáticamente ao alterar"
                    >
                        <font-awesome-icon
                            icon="wand-magic-sparkles"
                            :class="
                                autoSearch
                                    ? 'btn-simple-blue'
                                    : 'btn-simple-gray'
                            "
                        />
                    </button>
                    <button
                        type="button"
                        @click="makeRequest(true)"
                        class="btn-simple-gray"
                        title="Limpar filtro"
                    >
                        <font-awesome-icon
                            icon="fa-solid fa-eraser"
                         />
                    </button>
                    <template v-if="hasFilter">
                        <ExportBtn
                            v-if="cFilter?.export?.length > 0"
                            :options="$page.props.filter.export"
                            :filter="search?.form"
                            :right="true"
                            @exportFile="(file) => exportFile(file)"
                            title="Exportar Filtrado"
                        ></ExportBtn>
                    </template>
                </div>
            </div>
            <form @submit.prevent="makeRequest(false)" class="flex flex-col w-full flex-1 overflow-y-auto">
                <template v-if="hasFilter && !$page.props.custom_filter">
                    <div class="flex flex-col w-full h-full gap-2 overflow-y-auto">
                    <NakedForm
                        :routeName="cFilter.routeName"
                        :formComponents="cFilter.components"
                        :options="{ required: false }"
                        :errors="{}"
                        ref="search"
                        :request="$page.props.request"
                    ></NakedForm>
                    </div>
                </template>
                <template v-else-if="hasFilter && $page.props.custom_filter">
                    <AsyncComponent
                        :path="$page.props.custom_filter?.path"
                        :options="{ required: false }"
                        :errors="{}"
                        ref="search"
                        :request="$page.props.request"
                        v-bind="{
                            ...$page.props.custom_filter?.props,
                        }"></AsyncComponent>
                </template>
                <div
                    v-else
                    class="h-full flex items-center justify-center text-center text-lg w-full py-2 dark:text-white"
                >
                    <span>Não há filtros disponíveis para esta tela.</span>
                </div>

                <div class="absolute right-0 bottom-2 w-full px-2">
                    <button
                        type="submit"
                        class="w-full rounded-md transition-colors ease-in-out duration-150 py-1 btn-outline-violet font-bold"
                        @click="makeRequest(false)"
                        v-if="hasFilter"
                    >
                        FILTRAR
                    </button>
                </div>
            </form>
        </div>
    </transition>
</template>

<script setup>
import { useStore } from "vuex";
import debounce from "lodash/debounce";
import { ref, computed, watch, toRaw } from "vue";
import { router, usePage } from "@inertiajs/vue3";
import NakedForm from "@/Components/Custom/Filter/NakedForm.vue";
import ExportBtn from "../Buttons/ExportBtn.vue";
import AsyncComponent from "@/Components/AsyncComponent.vue";

const store = useStore();
const isCustomFilter = computed(() => {
    if(usePage().props?.custom_filter?.routeName){
        return true;
    }

    return false;
})
const hasFilter = computed(() => {
    if(isCustomFilter.value){
        return true;
    }

    if(usePage().props?.filter?.routeName){
        return true;
    }

    return false
});

const cFilter = computed(() => usePage().props?.filter);

const filterVisible = computed(() =>
    hasFilter.value == true ? store.state.filterVisible : false
);
const autoSearch = computed({
    get() {
        return store.state.autoSearch;
    },
    set() {
        store.dispatch("toggleAutoSearch");
    },
});

const cRequest = computed(() => usePage().props?.request)

const search = ref(null);
const searchComputed = computed(() => {
    if(isCustomFilter.value){
        return search.value?.asyncRef?.form??{}
    }
    return search.value?.form??{}
})
function removerVazio(val){
    return _.omitBy(
        val,
        (v) => _.isUndefined(v) || _.isNil(v) || v === ""
    );
}

function makeRequest(clear = false) {
    let filter = isCustomFilter.value ? usePage().props?.custom_filter : usePage().props?.filter
    let url;

    if (filter.routeParams) {
        url = route(filter.routeName, filter.routeParams);
    } else {
        url = route(filter.routeName);
    }

    let formSemNulo = clear ? {clear: true} : removerVazio(searchComputed.value)
    if(clear && usePage().props?.custom_filter){
        search.value.asyncRef.reset()
    }
    return router.get(url, formSemNulo, {
        preserveState: true,
        replace: true,
    });
}



const oldForm = ref(null);

const watcher = watch(
    () => search.value?.form,
    debounce((val, old) => {

        // Se tiver marcado o autoSearch && o filtro estiver montado;
        let formIsDifferentFromRequest = !_.isEqual(removerVazio(toRaw(val)), removerVazio(toRaw(cRequest.value)));

        if (autoSearch.value === true && val && formIsDifferentFromRequest) {
            oldForm.value = _.cloneDeep(val);
            makeRequest();
        }
    }, 2500),
    {
        deep: true,
    }
);

const customSearchWatcher = watch(
    () => search.value?.asyncRef?.form,
    debounce((val, old) => {
        // Se tiver marcado o autoSearch && o filtro estiver montado;
        let formIsDifferentFromRequest = !_.isEqual(removerVazio(toRaw(val)), removerVazio(toRaw(cRequest.value)));

        if (autoSearch.value === true && val && formIsDifferentFromRequest) {
            oldForm.value = _.cloneDeep(val);
            makeRequest();
        }
    }, 500),
    {
        deep: true,
    }
);

watch(
    hasFilter,
    (val) => {
        if (!val && store.state.filterVisible == true) {
            store.dispatch("setFilterVisible");
        }
    },
    { immediate: true }
);

</script>

<style></style>
